import React, { FC, useCallback } from 'react'
import { AdProps, ComponentType, TeaserProps } from '@sport1/types/web'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import { RenderListItemProps, SystemSpacingsProps } from '@sport1/news-styleguide/Types'
import { ItemCardProps } from '@/components/TeaserCard'
import { TeaserSizeTypes } from '@/types/teaser'
import HorizontalSlider from '@/components/HorizontalSlider'

const HorizontalCardContent: FC<ItemCardProps & SystemSpacingsProps> = ({
    teaser,
    backgroundColor,
    getTeaserComponent,
    horizontalScrollbarEnabled,
    arrowMargin,
    spaceX,
}) => {
    const renderItem = useCallback(
        ({ index }: RenderListItemProps<TeaserProps | AdProps>) => {
            return getTeaserComponent({
                index,
                type: TeaserSizeTypes.MID,
                isCardTeaser: true,
                noExpand: true,
                headlineNumberOfLines: 2,
                includeAdsForSizes: { isDesktop: true, isTablet: true, isMobile: true },
            })
        },
        [getTeaserComponent]
    )

    const keyExtractor = useCallback(
        (item: TeaserProps | AdProps, index: number) =>
            item.type !== ComponentType.AD
                ? `${item.title}_${item.publishedAt}_${index}`
                : `${item.adIndex}_${index}`,
        []
    )

    return (
        <NonFlexingContainer>
            <HorizontalSlider<TeaserProps | AdProps>
                items={teaser}
                keyExtractor={keyExtractor}
                renderItem={renderItem}
                backgroundColor={backgroundColor}
                spaceX={spaceX || 'none'}
                horizontalScrollbarEnabled={horizontalScrollbarEnabled}
                arrowMargin={arrowMargin}
                itemWidth={290}
            />
        </NonFlexingContainer>
    )
}

export default HorizontalCardContent
